function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#5dbeff"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 82",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 41,
  height: 61,
  rx: 4,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 39,
  height: 59,
  rx: 3
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 83",
  transform: "translate(0 63)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 6,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 38,
  height: 4,
  rx: 1
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 6",
  d: "M11.5 11.5h20"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 7",
  d: "M11.5 17.5h20"
}));

var SvgBackend = function SvgBackend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 69",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/backend.c7cecc37.svg";
export { ForwardRef as ReactComponent };